<template>
  <div>
    <h1>Admin</h1>
  </div>
</template>

<script setup>
const cookie = useCookie('admin', {
  maxAge: 60 * 60 * 24 * 365 * 10
})
cookie.value = '1'
</script>
